import { render, staticRenderFns } from "./goodsDetailDialog.vue?vue&type=template&id=8973558c&scoped=true&"
import script from "./goodsDetailDialog.vue?vue&type=script&lang=js&"
export * from "./goodsDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetailDialog.vue?vue&type=style&index=0&id=8973558c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8973558c",
  null
  
)

export default component.exports